import { render, staticRenderFns } from "./CreateSubDepartmentDialog.vue?vue&type=template&id=9a451a9e&scoped=true&"
import script from "./CreateSubDepartmentDialog.vue?vue&type=script&lang=js&"
export * from "./CreateSubDepartmentDialog.vue?vue&type=script&lang=js&"
import style0 from "./CreateSubDepartmentDialog.vue?vue&type=style&index=0&id=9a451a9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a451a9e",
  null
  
)

export default component.exports